/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "./utils/axiosInstance";
import toast from "react-hot-toast";
import { addCart } from "../redux/slices/Cart";

const CheckoutOrderBox = ({ couponInput = true, setSubmit }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartData = useSelector((state) => state.cart.cart);
  const [subtotal, setSubTotal] = useState(0);

  const [couponCode, setCouponCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!couponCode) {
      setError("Coupon code is required");
    } else {
      try {
        const formData = new FormData();
        formData.append("code", couponCode);
        formData.append("total_price", subtotal);

        const response = await axiosInstance.post("user/coupon", formData);

        if (response.data.status === true) {
          toast.success(response.data.message || "Discount successful..!");

          dispatch(
            addCart(
              cartData.map((item) => ({
                ...item,
                discount: response?.data?.coupon?.percent,
              }))
            )
          );
        }
      } catch (error) {
        toast.error("An error occurred");
      }
    }
  };

  useEffect(() => {
    const total = cartData.reduce((acc, item) => {
      return acc + (item?.price * item?.quantity || 0);
    }, 0);

    setSubTotal(total);
  }, [cartData]);

  return (
    <>
      <div className="wow fadeInUp" data-wow-duration="1s">
        <div id="sticky_sidebar" className="cart_list_footer_button">
          <div className="cart_list_footer_button_text">
            <h6>total cart ({cartData.length})</h6>
            <p>
              subtotal: <span>${subtotal}</span>
            </p>
            <p>
              Discount:
              <span>
                $
                {cartData[0]?.discount
                  ? (subtotal * cartData[0]?.discount) / 100
                  : 0}
              </span>
            </p>

            <p className="total">
              <span>total:</span>
              <span>
                $
                {cartData[0]?.discount
                  ? subtotal - (subtotal * cartData[0]?.discount) / 100
                  : subtotal}
              </span>
            </p>
            {couponInput && (
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  required
                  placeholder="Coupon Code"
                />
                <button type="submit">Apply</button>
                {error && <p className="text-red">{error}</p>}
              </form>
            )}

            {cartData?.length > 0 ? (
              <a
                className="common_btn"
                style={{ cursor: "pointer" }}
                onClick={
                  couponInput
                    ? () => setSubmit(true)
                    : () => navigate("/checkout")
                }

                // onClick={() => navigate("/checkout")}
              >
                checkout
              </a>
            ) : (
              <a
                className="common_btn"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  toast.error("No Cart Availabel For Checkout");
                }}

                // onClick={() => navigate("/checkout")}
              >
                checkout
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutOrderBox;
